import React, { useMemo } from 'react';
import { useSingleEffect } from 'react-haiku';

import DayJs from 'utils/Dayjs';
import { WEBINAR_TYPES } from 'utils/Constants';

import Show from 'components/Show';
import Pill from 'components/Misc/Pill';
import { Button } from 'components/Misc/Form';
import Container from 'components/Misc/Container';
import { Title } from 'components/Misc/Typography';

import { useWebinarProfileStore } from 'store/webinar/useWebinarProfileStore';

const Preview = ({ tab, setTab }) => {
	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use webinar's profile store	
	const [webinar, course, subject] = useWebinarProfileStore(state => [
		state.webinar,
		state.course,
		state.subject
	]);

	// Find type info
	const type = useMemo(() => WEBINAR_TYPES.find(type => type.value === webinar?.type), [webinar]);

	// Store if webinar is done
	const hasEnded = useMemo(() => DayJs(webinar?.eventAt).isBefore(DayJs().subtract(2, 'hour')), [webinar]);
	const hasStarted = useMemo(() => DayJs().add(15, 'minute').isAfter(DayJs(webinar?.eventAt)), [webinar]);

	return (
		<Container className="mt-4 p-4 space-y-4">
			{/* Webinar's information */}
			<div className="flex items-center space-x-2">
				<Title
					title={course?.title}
					subtitle={subject?.title}
					className="flex-1 text-xl"
				/>

				<Pill name={type?.text} />
			</div>

			{/* Webinar's video */}
			<Show if={webinar.type === 'record' && webinar.url}>
				<video controls className="w-full rounded-lg">
					<source src={webinar.url} />
				</video>
			</Show>

			{/* Webinar's join section */}
			<Show if={webinar.type === 'online'}>
				{/* Information block after */}
				<Show if={hasEnded}>
					<div className="text-neutral-800 dark:text-white transition-colors">
							Vebinārs ir noslēdzies! Drīzumā tam būs pieejams ieraksts, kuru varēsi atrast dotā moduļa vebināru sarakstā!
					</div>
				</Show>

				{/* Information block before */}
				<Show if={!hasEnded && !hasStarted}>
					<div className="text-neutral-800 dark:text-white transition-colors">
							Vebināram varēs pieslēgties 15 minūtes pirms paredzētā laika! Ja ir tehniskas problēmas, zvaniet: 28604888
					</div>
				</Show>
				
				{/* Information block in last minutes */}
				<Show if={!hasEnded && hasStarted}>
					<div className="text-neutral-800 dark:text-white transition-colors">
							Spied uz pogas <b>&quot;Pieslēgties&quot;</b>, lai piedalītos <b>&quot;Zoom&quot;</b> vebinārā!
					</div>
				</Show>

				<div className="flex justify-end">
					<Button
						icon="link"
						theme="success"
						value="Pieslēgties"
						toOutside={(hasEnded || !hasStarted) ? '' : webinar?.url}
						disabled={hasEnded || !hasStarted}
					/>
				</div>
			</Show>
		</Container>
	);
};

export default Preview;